import axios from "axios";
import { axiosPalantirApi } from "../../../utils/axiosAPICall";

const API_BASE_URL = "http://localhost:8080"; 
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "dev-key-123",
  },
});

// Optional: Add global error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export async function getDDQuestionerData(userId,data) {
    return await axiosPalantirApi.get(`/v1/Lucra/StartAnalysis?currentUserID=${userId}`, data)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

export async function getDDQuestionerDataByCompanyId(companyId) {
    return await apiClient.get(`/api/v1/ddq/list/${companyId}`)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

export async function getDDSelectionTypesByCompanyId(companyId) {
    return await axiosPalantirApi.get(`/api/v1/ddq-selection/types/${companyId}`)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

export const getDDQStatistics = async () => {
  try {
    const response = await apiClient.get("/api/v1/ddq-template/statistics");
    return response.data;
  } catch (error) {
    console.error("Error fetching DDQ statistics:", error);
    return null;
  }
};

export async function getDDQSummaryAnalytics(companyId) {
    return await apiClient.get(`/api/v1/ddq/summaryanalytics/${companyId}`)
    .then(res => {
        return res;
    }).catch(error => {
        return error;
    });
}

